export default __webpack_public_path__ + "static/media/zoro.1c083f44.jpg";